import { updateQueryStringParam, updateLinkQueryStringParam } from '../helpers/edit_query_string.js';

$(document).ready(function(){

  // home_logged_out.html.erb
  var stickyNav = $('.js-sticky-nav');
  if (stickyNav.length > 0) {
    var appearAfter = $('.js-home-header');
    var offset = appearAfter.height();
    var $window = $(window);

    function checkScroll() {
      if ($window.scrollTop() > offset) {
        if (stickyNav.hasClass('dc-is-hidden')) {
          stickyNav.removeClass('dc-is-hidden');
        }
      } else {
        stickyNav.addClass('dc-is-hidden');
      }
    }
    $window.on("scroll", checkScroll);
    $window.on("resize",checkScroll);
  }

  function saveVariantLocalStorage(value) {
    localStorage.setItem('feature-plan-variant', value);
  }

  if (String(document.location.search).substr(document.location.search.lastIndexOf('variant=') + 8) !== "") {
    saveVariantLocalStorage(String(document.location.search).substr(document.location.search.lastIndexOf('variant=') + 8));
  }

  showContent(localStorage.getItem('feature-plan-variant'));

  // Business/individual switch
  $(".js-dc-toggle-content input").on("click", function(event) {
    var checked = $(this).attr("value");
    showContent(checked);
    updateQueryStringParam('variant', checked);
    updateLinkQueryStringParam('.logo-block a', 'variant', checked);
    updateLinkQueryStringParam("a:contains('Pricing')", 'variant', checked);
  });

  $(window).on('popstate', function(event) {
    var pathArray = String(window.location.pathname).split('/');
    showContent(String(document.location.search).substr(document.location.search.lastIndexOf('variant=') + 8));
  });

  function showContent(type) {
    saveVariantLocalStorage(type);
    if (type == "business") {
      $('.js-show-for-businesses').removeClass('dc-is-hidden');
      $('.js-show-for-individuals').addClass('dc-is-hidden');
      $('.js-home-toggle-business').prop( "checked", true );
    } else {
      $('.js-show-for-individuals').removeClass('dc-is-hidden');
      $('.js-show-for-businesses').addClass('dc-is-hidden');
      $('.js-home-toggle-individual').prop( "checked", true );
    }
  }
});
